/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiCountryCountriesGet } from '../fn/country/api-country-countries-get';
import { ApiCountryCountriesGet$Params } from '../fn/country/api-country-countries-get';
import { apiCountryOverviewGet } from '../fn/country/api-country-overview-get';
import { ApiCountryOverviewGet$Params } from '../fn/country/api-country-overview-get';
import { CountryNames } from '../models/country-names';
import { CountryOverviewList } from '../models/country-overview-list';


/**
 * Country service
 */
@Injectable({ providedIn: 'root' })
export class CountryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiCountryCountriesGet()` */
  static readonly ApiCountryCountriesGetPath = '/api/country/countries';

  /**
   * Get countries.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCountryCountriesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCountryCountriesGet$Response(params?: ApiCountryCountriesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CountryNames>> {
    return apiCountryCountriesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get countries.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCountryCountriesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCountryCountriesGet(params?: ApiCountryCountriesGet$Params, context?: HttpContext): Observable<CountryNames> {
    return this.apiCountryCountriesGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CountryNames>): CountryNames => r.body)
    );
  }

  /** Path part for operation `apiCountryOverviewGet()` */
  static readonly ApiCountryOverviewGetPath = '/api/country/overview';

  /**
   * Get country overview.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCountryOverviewGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCountryOverviewGet$Response(params?: ApiCountryOverviewGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CountryOverviewList>> {
    return apiCountryOverviewGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get country overview.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCountryOverviewGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCountryOverviewGet(params?: ApiCountryOverviewGet$Params, context?: HttpContext): Observable<CountryOverviewList> {
    return this.apiCountryOverviewGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CountryOverviewList>): CountryOverviewList => r.body)
    );
  }

}
